module.exports = __webpack_public_path__ + "img/syukyaku-kaisya-002.1571f5f3.jpg";